import { useContext } from "react";
import { Box, Flexbox, Tabs, Text } from "@profiler/ui";

import { AppContext } from "../../context/AppContext";
import { JsonView } from "./JsonView";

const ErrorMessage = ({ message }: { message: string | null }) =>
  message ? (
    <Flexbox justifyContent="center" mb={3} padding={3} border={3}>
      <Text>{message}</Text>
    </Flexbox>
  ) : null;

export const ResultViewer = () => {
  // const { toggle: toggleAlert } = useAlert();
  // const { toggle: toggleLoader } = useLoader();

  // TODO: !!!
  const errorMessage = null;

  const {
    response: { data: responseData },
  } = useContext(AppContext);

  if (!responseData) return null;

  return (
    <Box overflow="auto" width="100%" padding={1}>
      <ErrorMessage message={errorMessage} />

      <Tabs defaultValue={0}>
        <JsonView content={responseData} />
      </Tabs>
    </Box>
  );
};
